export const urls = {
  applyCampaignJourney: () => `/api/client/v1/marketing/campaign-journeys/apply/`,
};
